import * as React from 'react'
import MediaQuery from 'react-responsive'
import { connect } from 'react-redux'
import {
  Text,
  StackChildren,
  Breakpoints,
  InlineChildren,
} from '@doordash/design-language'
import Button from '@doordash/component-button'
import { isWebview, detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import { PreparingArchive as PreparingArchiveImg } from '../../atoms/images/privacy-portal/preparing-archive'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import ResponsiveWrapper from '../../atoms/responsive-wrapper'
import s from './strings'

const RTI_IOS_CLOSE_DEEPLINK = `comdoordashdriver://privacy/rti/completed`
const RTI_ANDROID_CLOSE_DEEPLINK = `dddriver://privacy/rti/completed`

type Props = {
  trackRTI?: (data: DA.RTI) => void
}

export const PreparingArchive: React.FC<Props> = ({ trackRTI }) => {
  const os = detectWebviewOs()
  const onClickHandler = async () => {
    try {
      trackRTI({ action: DA.GDPRActions.Exit })

      if (isWebview()) {
        window.location.assign(
          os === OsTypes.iOS
            ? RTI_IOS_CLOSE_DEEPLINK
            : RTI_ANDROID_CLOSE_DEEPLINK
        )
      } else {
        window.location.reload()
      }
    } catch (e) {
      console.warn(e)
      trackRTI({ action: DA.GDPRActions.Error })
    }
  }

  return (
    <ResponsiveWrapper>
      <StackChildren size={StackChildren.Sizes.Large}>
        <InlineChildren justifyContent={InlineChildren.Justification.Center}>
          <PreparingArchiveImg />
        </InlineChildren>
        <StackChildren size={StackChildren.Sizes.Small}>
          <Text styles={Text.Styles.PageTitle2}>{s.title()}</Text>
          <Text styles={Text.Styles.Body1}>{s.body()}</Text>
        </StackChildren>
        <MediaQuery minWidth={Breakpoints.Mobile + 1}>
          <Button onClick={onClickHandler}>{s.button()}</Button>
        </MediaQuery>
      </StackChildren>
      <MediaQuery maxWidth={Breakpoints.Mobile}>
        <Button onClick={onClickHandler}>{s.button()}</Button>
      </MediaQuery>
    </ResponsiveWrapper>
  )
}

PreparingArchive.defaultProps = {
  trackRTI: () => {}, // noop
}

const mapDispatchToProps = {
  trackRTI: events.trackRTI,
}

export default connect(null, mapDispatchToProps)(PreparingArchive)
